
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const thatcher: Operator = {
	id: 'thatcher',
	name: 'Thatcher',
	role: 'Attacker',
	org: 'SAS',
	squad: 'VIPERSTRIKE',
	ratings: {
		health: 3,
		speed: 1,
		difficulty: 1
	},
	meta: {
		gender: 'm',
		country: 'uk',
		season: 'Release',
		height: 180,
		weight: 72,
		price: {
			renown: 1000,
			r6credits: 0
		}
	},
	bio: {
		real_name: 'Mike Baker',
		birthplace: 'Bideford, England'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#88666f"></path><path d="M232.198 114.561V95.667l9.691-23.838-9.691-14.746H204.25v-5.5h-57.5v5.5h-28.448l-9.691 14.746 9.691 23.838v18.894C100.042 130.465 88.5 153.884 88.5 180c0 47.911 38.839 86.75 86.75 86.75S262 227.911 262 180c0-26.116-11.542-49.535-29.802-65.439"></path><path d="M175 253.066c-40.289 0-73.066-32.777-73.066-73.066 0-18.563 7.397-37.048 20.295-50.713a8.566 8.566 0 0 1 12.459 11.759c-9.928 10.519-15.622 24.716-15.622 38.953 0 30.842 25.092 55.934 55.934 55.934s55.934-25.092 55.934-55.934c0-14.251-5.738-28.437-15.742-38.919a8.566 8.566 0 1 1 12.393-11.828c13.016 13.638 20.481 32.134 20.481 50.747 0 40.29-32.777 73.067-73.066 73.067" style="fill:#fff"></path><path d="M175 202.566a8.566 8.566 0 0 1-8.566-8.566v-76.223c0-4.731 3.835-8.566 8.566-8.566s8.566 3.835 8.566 8.566V194a8.566 8.566 0 0 1-8.566 8.566M227.014 65.5h-31.375v-5.417h-40.278V65.5h-32.2l-4.642 7.374 1.228 3.237 9.684 24.05a5.25 5.25 0 1 0 9.74-3.922l-8.104-20.128h21.711V94.13a3.125 3.125 0 1 0 6.25 0V76.111h13.625V94.13a3.125 3.125 0 1 0 6.25 0V76.111h13.917V94.13a3.125 3.125 0 1 0 6.25 0V76.111h20.146l-8.105 20.128a5.25 5.25 0 1 0 9.74 3.922L232 72.917z" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-thatcher'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
